/**
 * Created by vadimdez on 01/11/2016.
 */

import { NgModule } from '@angular/core';

import { PdfViewerComponent } from './pdf-viewer.component';
import { PDFJSStatic } from 'pdfjs-dist';

declare global {
  const PDFJS: PDFJSStatic;
}

export { PDFJSStatic, PDFDocumentProxy, PDFViewerParams, PDFPageProxy, PDFSource, PDFProgressData, PDFPromise } from 'pdfjs-dist';
export class PdfViewerModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [PdfViewerComponent],
  exports: [PdfViewerComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PdfViewerModule_tsickle_Closure_declarations() {
/** @type {?} */
PdfViewerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PdfViewerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
